module.exports = new __parcel__URL__("background.2ee3d97c.svg").toString();